import { render, staticRenderFns } from "./BannerSettingsView.vue?vue&type=template&id=4b121bc8&scoped=true"
import script from "./BannerSettingsView.vue?vue&type=script&lang=js"
export * from "./BannerSettingsView.vue?vue&type=script&lang=js"
import style0 from "./BannerSettingsView.vue?vue&type=style&index=0&id=4b121bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b121bc8",
  null
  
)

export default component.exports